import {Button, useModal} from '@blesk-frontend/ui';
import {FeedbackModal} from '@/components';

export const FeedbackButton = () => {
  const openFeedbackModal = useModal((props) => <FeedbackModal {...props} />);

  if (import.meta.env.VITE_ON_PREMISE_CLIENT_ID) {
    return null;
  }

  return (
    <Button
      onClick={() => openFeedbackModal()}
      variant="outline"
      className="border-none bg-[#FDE68A] px-6 text-text-secondary hover:border-none hover:bg-attention-primary"
    >
      Написать разработчикам
    </Button>
  );
};
